var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarroDeLaCompra1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.2,345.2c-8,0-15.2-5.6-16.8-13.6L87.2,149.2c-2.4-9.6,4-18.4,13.6-20.8c9.6-2.4,18.4,4,20.8,13.6l39.2,182.4 c1.6,9.6-4,18.4-13.6,20.8C145.6,345.2,144.8,345.2,143.2,345.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.4,345.2c-0.8,0-2.4,0-4,0c-9.6-2.4-15.2-11.2-13.6-20.8L300,142c2.4-9.6,11.2-15.2,20.8-13.6 c9.6,2.4,15.2,11.2,13.6,20.8l-39.2,182.4C293.6,339.6,286.4,345.2,278.4,345.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212,342c-9.6,0-16-8-16-17.6V142c0-9.6,6.4-17.6,16-17.6s16,8,16,17.6v182.4C228,334,221.6,342,212,342z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18456D"
    },
    d: "M420.8,146.8c1.6-5.6,0.8-12-2.4-16.8c-3.2-4.8-8.8-8-14.4-8H17.6c-5.6,0-10.4,4-14.4,8 c-3.2,4.8-4,10.4-2.4,16l40,128l2.4,8L60,335.6c2.4,7.2,8.8,10.4,16.8,10.4h268c8,0,14.4-3.2,16.8-10.4l17.6-54.4 c0.8-2.4,1.6-4,2.4-6.4L420.8,146.8z M61.6,226H360l-9.6,32H71.2L61.6,226z M380.8,162l-9.6,24H50.4l-9.6-24H380.8z M89.6,314 l-7.2-24H340l-8,24H89.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B3249"
    },
    d: "M404,130H17.6c-5.6,0-10.4,4-14.4,8c-1.6,1.6-2.4,4.8-3.2,7.2c0,0,0,0.8,0,1.6l40,128l3.2,7.2 L60,335.6c2.4,7.2,8.8,10.4,16.8,10.4h268c8,0,14.4-3.2,16.8-10.4l17.6-54.4c0.8-2.4,1.6-4,2.4-6.4l40-128c0-0.8,0-0.8,0-0.8 c-0.8-2.4-1.6-5.6-3.2-7.2C415.2,134,409.6,130,404,130z M340,298l-8,24H89.6l-7.2-24h2.4l-2.4-8H340l-2.4,8H340z M360,234l-9.6,32 H71.2l-9.6-32H64l-2.4-8H360l-2.4,8H360z M380.8,170l-9.6,24H50.4l-9.6-24h2.4l-2.4-8h340l-2.4,8H380.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B3249"
    },
    d: "M354.4,410H67.2c-9.6,0-17.6-6.4-17.6-16s8-16,17.6-16h287.2c9.6,0,17.6,6.4,17.6,16 C372,403.6,364,410,354.4,410z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6,410h113.6c0-16-16-24-34.4-32H99.2C88.8,386,81.6,394,81.6,410z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E3451"
    },
    d: "M168.8,412.4c0,24-19.2,46.4-43.2,46.4s-43.2-22.4-43.2-46.4s19.2-43.2,43.2-43.2 C149.6,368.4,168.8,388.4,168.8,412.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2689C6"
    },
    d: "M168.8,412.4c0,24-19.2,43.2-43.2,43.2s-43.2-19.2-43.2-43.2s19.2-47.2,43.2-47.2 C149.6,365.2,168.8,388.4,168.8,412.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1B5A89"
    },
    cx: 125.6,
    cy: 412.4,
    r: 43.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18456D"
    },
    d: "M94.4,381.2c16.8-16.8,44.8-16.8,61.6,0s16.8,44.8,0,61.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B3249"
    },
    d: "M125.6,438c-14.4,0-25.6-11.2-25.6-25.6s11.2-25.6,25.6-25.6s25.6,11.2,25.6,25.6 C151.2,426,139.2,438,125.6,438z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.2,394c10.4,10.4,10.4,26.4,0,36.8s-26.4,10.4-36.8,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.4,410H356c0-16-16-24-34.4-32H260C249.6,386,242.4,394,242.4,410z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E3451"
    },
    d: "M329.6,412.4c0,24-19.2,46.4-43.2,46.4s-43.2-22.4-43.2-46.4s19.2-43.2,43.2-43.2 C309.6,368.4,329.6,388.4,329.6,412.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2689C6"
    },
    d: "M329.6,412.4c0,24-19.2,43.2-43.2,43.2s-43.2-19.2-43.2-43.2s19.2-47.2,43.2-47.2 C309.6,365.2,329.6,388.4,329.6,412.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1B5A89"
    },
    cx: 285.6,
    cy: 412.4,
    r: 43.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18456D"
    },
    d: "M255.2,381.2c16.8-16.8,44.8-16.8,61.6,0c16.8,16.8,16.8,44.8,0,61.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B3249"
    },
    d: "M285.6,438c-14.4,0-25.6-11.2-25.6-25.6s11.2-25.6,25.6-25.6s25.6,11.2,25.6,25.6 C312,426,300,438,285.6,438z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304,394c10.4,10.4,10.4,26.4,0,36.8s-26.4,10.4-36.8,0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B5A89"
    },
    d: "M500,82c0,8.8-7.2,16-16,16h-72c-8.8,0-16-7.2-16-16l0,0c0-8.8,7.2-16,16-16h72 C492.8,66,500,73.2,500,82L500,82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18456D"
    },
    d: "M413.6,66c-8,0-14.4,4.8-16.8,12c2.4,7.2,8.8,12,16.8,12h71.2c8,0,12.8-4.8,15.2-12 c-1.6-6.4-8-12-16-12H413.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58A300"
    },
    d: "M411.2,74.8c-16,0-31.2-2.4-47.2-6.4l0,0l0,0l0,0l0,0c-8,4-27.2,6.4-43.2,6.4 c-16.8,0-36.8-2.4-44.8-7.2v145.6c0,40,40,72.8,88,77.6l0,0l0,0l0,0l0,0c56-5.6,96-37.6,96-77.6V67.6C444,72.4,428,74.8,411.2,74.8z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82CC00"
    },
    d: "M411.2,67.6c-16,0-31.2-22.4-47.2-26.4l0,0l0,0l0,0l0,0c-8,4-27.2,26.4-43.2,26.4 c-16.8,0-36.8-2.4-44.8-7.2V206c0,40,40,72.8,88,77.6l0,0l0,0l0,0l0,0c56-5.6,96-37.6,96-77.6V60.4C444,65.2,428,67.6,411.2,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DBA02"
    },
    d: "M364,282v1.6l0,0l0,0l0,0c56-5.6,96-37.6,96-77.6V60.4c-16,4.8-32,7.2-48.8,7.2 c-16,0-31.2-22.4-47.2-26.4l0,0l0,0l0,0V42"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58A300"
    },
    d: "M352,210.8c-1.6,0-3.2-0.8-4.8-1.6l-28-28c-2.4-2.4-2.4-6.4,0-9.6c2.4-2.4,6.4-2.4,9.6,0l24,24 l53.6-53.6c2.4-2.4,6.4-2.4,9.6,0c2.4,2.4,2.4,6.4,0,9.6L357.6,210C355.2,210,353.6,210.8,352,210.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M352,198c-1.6,0-3.2-0.8-4.8-1.6l-28-28c-2.4-2.4-2.4-6.4,0-9.6c2.4-2.4,6.4-2.4,9.6,0l24,24 l53.6-53.6c2.4-2.4,6.4-2.4,9.6,0c2.4,2.4,2.4,6.4,0,9.6l-58.4,58.4C355.2,197.2,353.6,198,352,198z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarroDeLaCompra1);
export default __webpack_public_path__ + "static/media/carro-de-la-compra-1.eb0cd80802e34db474d265750a2842a5.svg";
export { ForwardRef as ReactComponent };